import { render, staticRenderFns } from "./UsageStatisticsCopyTable.vue?vue&type=template&id=17bc5405&"
import script from "./UsageStatisticsCopyTable.vue?vue&type=script&lang=ts&"
export * from "./UsageStatisticsCopyTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports